import { GridColDef } from '@mui/x-data-grid';

const useDescargableHistorialTable = () => {
    
    const columns: GridColDef[] = [
        {
          field: 'id',
          headerName: 'ID',
          width: 200,
        },
       
        {
            field: 'descargable',
            headerName: 'Descargable',
            width: 400
        },
        {
            field: 'usuario',
            headerName: 'Usuario',
            width: 500,
        },
        {
            field: 'fecha_descarga',
            headerName: 'Registro',
            width: 300,
          
        },
    ];

    return {
        columns
    }

}

export default useDescargableHistorialTable